import {
  createPlugin,
  createRouteRef,
  createRoutableExtension,
  createComponentExtension,
  createApiFactory,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { censusApiRef, CensusApiClient } from './api';

export const censusRouteRef = createRouteRef({
  id: 'census',
});

export const techSummaryRouteRef = createRouteRef({
  id: 'tech-summary',
});

export const uiReposRouteRef = createRouteRef({
  id: 'ui-repos',
});

export const censusPlugin = createPlugin({
  id: 'census',
  featureFlags: [
    { name: 'fleet-census' },
    { name: 'kubernetes' },
    { name: 'census-mobile-platforms' },
  ],
  apis: [
    createApiFactory({
      api: censusApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new CensusApiClient(discoveryApi, fetchApi),
    }),
  ],
  routes: {
    root: censusRouteRef,
    techSummary: techSummaryRouteRef,
    uiRepos: uiReposRouteRef,
  },
});

export const FleetOverviewPage = censusPlugin.provide(
  createRoutableExtension({
    name: 'FleetOverviewPage',
    component: () =>
      import('./components/FleetOverviewPage').then(m => m.FleetOverviewPage),
    mountPoint: censusRouteRef,
  }),
);

export const TechSummaryPage = censusPlugin.provide(
  createRoutableExtension({
    name: 'TechSummaryPage',
    component: () =>
      import('./components/TechSummaryPage').then(m => m.TechSummaryPage),
    mountPoint: techSummaryRouteRef,
  }),
);

export const UiReposPage = censusPlugin.provide(
  createRoutableExtension({
    name: 'UiReposPage',
    component: () =>
      import('./components/UiReposPage/UiReposPage').then(m => m.UiReposPage),
    mountPoint: uiReposRouteRef,
  }),
);

export const CensusEntityTab = censusPlugin.provide(
  createComponentExtension({
    name: 'CensusEntityTab',
    component: {
      lazy: () =>
        import('./components/CensusEntityTab').then(m => m.CensusEntityTab),
    },
  }),
);
